import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutActions } from '../store';
import {
  Typography, Box, Modal, Snackbar, makeStyles
} from '@material-ui/core';
import MaintListTable from './MaintListTable';
import { api_call } from '../helpers/untils';
import MaintSimpleSettingModal from './MaintSimpleSettingModal';
import MaintSettingModal from './MaintSettingModal';

const MaintModal = (props) => {
  const { open, setOpen, deviceItem, history, onClickPL, loadFrom = "devicePage" } = props;
  const deviceId = deviceItem.id;
  const [modalType, setModalType] = useState('');

  const loadPageData = async (deviceId) => {
    console.log(`deviceItem::::`, deviceItem);

    if (deviceId) {
      const url = `/api/maint/${deviceId}`
      const response = await api_call(url);
      if (response.ok) {
        const responseObj = await response.json();
        const maintItemList = responseObj.maintItemList;
        if (maintItemList.length > 0) {
          setModalType('advanced');
        }
        else {
          setModalType('simple');
        }
      }
    } else {
      setModalType('simple');
    }
  }

  useEffect(() => {
    if (open) {
      setModalType("");
      loadPageData(deviceId);
    }
  }, [deviceId, open]);

  return (
    <>
      {
        (modalType === 'simple') ? (
          <>
            <MaintSimpleSettingModal
              {...props}
            />
          </>
        ) : (modalType === 'advanced') ? (
          <>
            <MaintSettingModal
              {...props}
              loadFrom={loadFrom}
            />
          </>
        ) : (
          <></>
        )
      }
    </>
  );
};

export default MaintModal;
